import { Box, Stack } from '@mui/material';

import clsx from 'clsx';

import RadioGroup from '../../../../../components/HookFormControls/RadioGroup';
import RichTextView from '../../../../../components/RichText/View';
import { SAFE_EMPTY_STRING } from '../../../../../db/polls/constants';
import NoPolls from '../../../NoPolls';
import { FormValues } from '../types';
import Skeleton from './Skeleton';
import { PollCard, PollDetailsPopper, pollListClasses, RadioOption } from './styles';
import usePollList from './vm';
import { PollListProps } from './types';

const PollList = <T extends FormValues>({
  isLoading,
  classStartTime,
  polls,
  noDataMessage,
  className,
  ...vmOptions
}: PollListProps<T>) => {
  const { control, name } = vmOptions;

  const { selectedPollId } = usePollList(vmOptions);

  if (isLoading) {
    return <Skeleton className={className} />;
  }

  if (polls.length === 0) {
    return <NoPolls message={noDataMessage} className={className} />;
  }

  return (
    <RadioGroup control={control} name={name} fullWidth className={className}>
      <Stack gap={2} px={2} py={0.5} maxWidth="100%">
        {polls.map((poll) => {
          const { activityId, hoverDetails } = poll;
          return (
            <RadioOption key={activityId} value={activityId}>
              <PollDetailsPopper
                title={
                  !hoverDetails || hoverDetails === SAFE_EMPTY_STRING ? null : (
                    <Box p={2}>
                      <RichTextView richtext={hoverDetails} />
                    </Box>
                  )
                }
                placement="left"
                PopperProps={{
                  modifiers: [
                    {
                      name: 'offset',
                      options: {
                        offset: [0, -6],
                      },
                    },
                    {
                      name: 'preventOverflow',
                      options: {
                        altBoundary: true,
                      },
                    },
                  ],
                }}
              >
                <Box flex={1} overflow="hidden">
                  <PollCard
                    poll={poll}
                    classStartTime={classStartTime}
                    className={clsx(pollListClasses.pollCard, {
                      [pollListClasses.selectedPoll]: activityId === selectedPollId,
                    })}
                  />
                </Box>
              </PollDetailsPopper>
            </RadioOption>
          );
        })}
      </Stack>
    </RadioGroup>
  );
};

export default PollList;
